// client/src/components/marketer/MarketerInquiryCheck.js
// 진행중인 문의 — A안 리디자인: 페이저 제거, 전체 리스트 + 상태 배지 (조회·캐시 로직은 기존 그대로)
import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

const KIND_LABELS = {
  point: '포인트 / 결제',
  project: '프로젝트 진행',
  profile: '계정 / 정보',
  'ad-agency': '광고 대행',
  report: '신고',
  etc: '기타',
};

function MarketerInquiryCheck() {
  const [userKey] = useState(() => {
    try { return sessionStorage.getItem('current_user_key') || ''; } catch { return ''; }
  });
  const cacheKey = userKey ? `marketer_inquiry_open__${userKey}` : '';

  const [items, setItems] = useState(() => {
    if (!cacheKey) return [];
    try {
      const raw = localStorage.getItem(cacheKey);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch { return []; }
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(() => {
    try { return !(cacheKey && localStorage.getItem(cacheKey)); } catch { return true; }
  });

  useEffect(() => {
    let alive = true;
    if (!userKey) return;
    (async () => {
      setError('');
      try {
        const res = await fetch(`${API_URL}/api/marketer/mybiz/inquiry/open`, { credentials: 'include' });
        const ct = res.headers.get('content-type') || '';
        let data = null;
        if (ct.includes('application/json')) data = await res.json().catch(() => ({}));
        else { await res.text(); throw new Error(`서버 응답 형식 오류(${res.status})`); }
        if (!res.ok || !data?.ok) throw new Error(data?.message || `불러오기 실패(${res.status})`);

        if (!alive) return;
        const next = Array.isArray(data.items) ? data.items : [];
        setItems(next);
        try { if (cacheKey) localStorage.setItem(cacheKey, JSON.stringify(next)); } catch {}
      } catch (e) {
        if (!alive) return;
        setError(e.message || '불러오기 실패');
      }
      setLoading(false);
    })();
    return () => { alive = false; };
  }, [userKey, cacheKey]);

  return (
    <div>
      <div className="mb-page-header">
        <h2 className="mb-page-title">진행중인 문의</h2>
        <p className="mb-page-description">접수된 문의는 순차적으로 답변해드려요.</p>
      </div>

      {error && (
        <div className="mb-card">
          <div className="note note--red" style={{ marginTop: 0 }}>{error}</div>
        </div>
      )}

      {loading && (
        <div className="mb-card" style={{ padding: 40, textAlign: 'center', color: '#6b7686', fontSize: 14, fontWeight: 600 }}>
          불러오는 중...
        </div>
      )}

      {!loading && !error && items.length === 0 && (
        <div className="mb-card" style={{ padding: '72px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: 17, fontWeight: 800, color: '#3b4658', marginBottom: 6 }}>
            진행중인 문의가 없어요
          </div>
          <div style={{ fontSize: 14, color: '#6b7686' }}>
            궁금한 점을 남겨주시면 빠르게 답변드릴게요
          </div>
        </div>
      )}

      {!loading && !error && items.map((item) => (
        <div className="mbh-inq" key={item._id || item.id}>
          <div className="mbh-inq__head">
            <span className="badge badge--blue">확인 중</span>
            <span className="mbh-inq__kind">{KIND_LABELS[item.kind] || item.kind || '-'}</span>
            <span className="mbh-inq__date">
              {item.createdAt ? new Date(item.createdAt).toLocaleString('ko-KR', { month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}
            </span>
          </div>
          <div className="mbh-inq__body">{item.content || ''}</div>
          <div className="mbh-inq__note mbh-inq__note--blue">
            담당자가 확인 중이에요. 등록된 메일 또는 연락처로 답변드릴게요.
          </div>
        </div>
      ))}
    </div>
  );
}

export default MarketerInquiryCheck;
